import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { getGroupedDependentAssetOptionsCount } from '../selectors/themeDependentAssetsSelectors';
import { useSelector } from 'react-redux';
import { Button } from 'foundations-components/transitional/components/Button';
import { useState } from 'react';
import EPDependentsItem from 'editor-components/modals/dependents/EPDependentsItem';
import { getGroupedDependentAssetOptions } from '../selectors/themeDependentAssetsSelectors';
import EPDependentsList from 'editor-components/modals/dependents/EPDependentsList';
import { getThemeName, getThemePath, getThemeImageUrl } from '../selectors/themeSelectors';
import { getThemeSettingsLastSave } from '../selectors/themeSettingsSelectors';
import { TrellisEPPreviewWrapper } from 'editor-components/preview/EPPreviewWrapper';
import EPDependentsPanel from '../components/EPDependentsPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UniversalContentPreviewWrapper = ({
  handleOpenRevisionsModal,
  templatePath,
  children
}) => {
  const dependentsCount = useSelector(getGroupedDependentAssetOptionsCount);
  const dependentAssetOptionGroups = useSelector(getGroupedDependentAssetOptions);
  const themeName = useSelector(getThemeName);
  const themePath = useSelector(getThemePath);
  const imageUrl = useSelector(getThemeImageUrl);
  const lastSave = useSelector(getThemeSettingsLastSave);
  const [showDependentsPanel, setShowDependentsPanel] = useState(false);
  const i18nKey = path => `theme-previewer.themeSettings.universal.${path}`;
  const toggleDependentsPanel = () => {
    setShowDependentsPanel(!showDependentsPanel);
  };
  const renderDependentItems = (dependents, linksDisabled) => {
    return dependents.map(dependent => {
      const {
        link,
        text,
        value
      } = dependent;
      return /*#__PURE__*/_jsx(EPDependentsItem, {
        linkDisabled: linksDisabled,
        link: link,
        children: text
      }, value);
    });
  };
  const renderDependentsList = () => {
    return dependentAssetOptionGroups.map(dependentsGroup => {
      const {
        disabledMessage,
        disableLinks,
        options,
        text
      } = dependentsGroup;
      if (!options.length) return null;
      return /*#__PURE__*/_jsx(View, {
        paddingInlineStart: "800",
        paddingInlineEnd: "800",
        children: /*#__PURE__*/_jsx(EPDependentsList, {
          disabledMessage: disabledMessage,
          disableLinks: disableLinks,
          title: text,
          children: renderDependentItems(options, disableLinks)
        }, text)
      }, text);
    });
  };
  const renderDependentsPanel = () => {
    if (!showDependentsPanel) return null;
    return /*#__PURE__*/_jsx(EPDependentsPanel, {
      themeName: themeName,
      imageUrl: imageUrl || '',
      themePath: themePath,
      templatePath: templatePath,
      onClose: toggleDependentsPanel,
      totalDependents: dependentsCount,
      lastSave: lastSave !== null && lastSave !== void 0 ? lastSave : 0,
      handleOpenRevisionsModal: handleOpenRevisionsModal,
      children: renderDependentsList()
    });
  };
  const getPreviewTitle = () => {
    const tooltipTitle = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('previewWrapperTooltip_jsx'),
      elements: {
        Button
      },
      options: {
        count: dependentsCount,
        name: themeName,
        onClick: toggleDependentsPanel
      }
    });
    return /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      justify: "center",
      direction: "row",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "theme-previewer.universalIframeHeader"
      }), /*#__PURE__*/_jsx(Tooltip, {
        placement: "bottom",
        title: tooltipTitle,
        children: /*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineStart: "200",
          marginBlockStart: "100",
          children: /*#__PURE__*/_jsx(InfoIcon, {
            size: "200"
          })
        })
      })]
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TrellisEPPreviewWrapper, {
      title: getPreviewTitle(),
      color: "fill-accent-teal-default",
      children: children
    }), renderDependentsPanel()]
  });
};
export default UniversalContentPreviewWrapper;